import { addDerzhatelBlock, resetDerzhatelBlocks } from "./addDerzhatelRulonaBlock";
import { addDopPolkaBlock, resetDopPolkaBlocks, thresholdDopPolka } from "./addDopPolka";
import { thresholdNumberShelves, addBlock, resetShelfBlocks } from "./addShelfBlock";
import { Y_MAP_SHELVES } from "./changeObjectParams/changes/stellazhi/pos_map";
import { changePerfopanel } from "./changeObjectParams/changes/tables/up/up";
import { hideAndRemoveAllActiveArrays } from "./changeObjectParams/helpers";
import { onElementAdded } from "./onElementAdded";

// Создаем изменяемые копии счетчиков
export async function applyFormData(data, formId) {
    const form = document.getElementById(formId);
    if (!form) {
        console.warn(`Форма с id "${formId}" не найдена!`);
        return;
    }

    const servObj = window?.servObj || parent.window?.servObj;

    // Сбрасываем полки, держатели и доп. полки перед применением новых данных
    resetShelfBlocks();
    resetDerzhatelBlocks();
    resetDopPolkaBlocks();
    servObj.counterDsp = 2;
    servObj.counterMetall = 2;
    servObj.counterDerzhatel = 2;
    servObj.thresholdDerzhatel = servObj.redactorModeObject.name.includes("stoyka") ? 4 : 5;
    servObj.counterDopPolka = servObj.redactorModeObject.name.includes("telezhka") ? 2 : thresholdDopPolka;

    // 1. Группируем значения по имени элемента
    const valueGroups = data.reduce((acc, item) => {
        if (!acc.has(item.name)) acc.set(item.name, new Set());
        acc.get(item.name).add(item.value);

        if (item.name === "table_width") servObj.tableSize.tableWidth.current = Number(item.value);
        if (item.name === "table_depth") servObj.tableSize.tableDepth.current = Number(item.value);
        if (item.name === "table_height") servObj.tableSize.tableHeight.current = Number(item.value);
        if (item.name === "metall_color") servObj.tableColor.changeable_painted_metal_material.current = item.value;
        if (item.name === "edge_color") servObj.tableColor.changeable_kromka_material.current = item.value;

        return acc;
    }, new Map());

    // 2. Обрабатываем динамические поля полок
    processShelvesData(form, valueGroups);

    // 2.1. Обрабатываем динамические поля держателей
    processDerzhatelData(form, valueGroups);

    // 2.1. Обрабатываем динамические поля держателей
    processDopPolkaData(form, valueGroups);

    // 3. Обрабатываем остальные элементы (исключая уже обработанные динамические поля)
    valueGroups.forEach((values, name) => {
        if (
            name.match(/^polka_pribornaya_(dsp|metall|depth|ogranichiteli)_\d+$/) ||
            name.match(/^derzhatel_rulona__\d+$/) ||
            name.match(/^bokovie_fiksatori__\d+$/)
        ) {
            return;
        }

        const elements = form.querySelectorAll(`[name="${name}"]`);

        if (elements.length === 0) return;

        applyValuesToElements(elements, values);
    });

    // 4. Триггерим общее событие для формы
    form.dispatchEvent(new Event("change", { bubbles: true }));
}

function processShelvesData(form, valueGroups) {
    const maxDspIndex = getMaxShelfIndex(valueGroups, "dsp");
    const maxMetallIndex = getMaxShelfIndex(valueGroups, "metall");
    const servObj = window?.servObj || parent.window?.servObj;

    // Добавляем недостающие DSP полки
    for (let i = 2; i <= maxDspIndex; i++) {
        if (i <= thresholdNumberShelves) {
            addBlock("polka_pribornaya_dsp", i, "polka_params_");
            servObj.counterDsp = i + 1;
        }
    }

    // Добавляем недостающие Metall полки
    for (let i = 2; i <= maxMetallIndex; i++) {
        if (i <= thresholdNumberShelves) {
            addBlock("polka_pribornaya_metall", i, "polka_params_");
            servObj.counterMetall = i + 1;
        }
    }

    // Применяем значения
    applyShelvesValues(form, valueGroups, "dsp", maxDspIndex);
    applyShelvesValues(form, valueGroups, "metall", maxMetallIndex);

    // Обновляем кнопки
    updateAddButtons(maxDspIndex, maxMetallIndex);
}

// Получаем максимальный индекс полки в данных
function getMaxShelfIndex(valueGroups, type) {
    let maxIndex = 1;
    for (const [name] of valueGroups) {
        const match = name.match(new RegExp(`^polka_pribornaya_${type}_(\\d+)$`));
        if (match) {
            const index = parseInt(match[1]);
            if (index > maxIndex) maxIndex = index;
        }
    }
    return Math.min(maxIndex, thresholdNumberShelves);
}

// Применяем значения к полкам
function applyShelvesValues(form, valueGroups, type, maxIndex) {
    for (let i = 1; i <= maxIndex; i++) {
        const shelfName = `polka_pribornaya_${type}_${i}`;
        const shelfInput = form.querySelector(`input[name="${shelfName}"]`);

        if (shelfInput) {
            // Устанавливаем состояние чекбокса полки
            shelfInput.checked = valueGroups.has(shelfName);

            // Для DSP полок обрабатываем глубину и ограничители
            if (type === "dsp" && shelfInput.checked) {
                applyDspAdditionalValues(form, valueGroups, i);
            }
        }
    }
}

// Применяем дополнительные значения для DSP полок
function applyDspAdditionalValues(form, valueGroups, index) {
    // Глубина
    const depthValues = valueGroups.get(`polka_pribornaya_depth_${index}`) || new Set();
    depthValues.forEach((value) => {
        const input = form.querySelector(`input[name="polka_pribornaya_depth_${index}"][value="${value}"]`);
        if (input) input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // Ограничители
    const ogranichiteliValues = valueGroups.get(`polka_pribornaya_ogranichiteli_${index}`) || new Set();
    ogranichiteliValues.forEach((value) => {
        const input = form.querySelector(`input[name="polka_pribornaya_ogranichiteli_${index}"][value="${value}"]`);
        if (input) input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });
}

// Обновляем состояние кнопок "Добавить ещё"
function updateAddButtons(maxDspIndex, maxMetallIndex) {
    const addDspBtn = document.querySelector(".btn_add.add_dsp");
    const addMetallBtn = document.querySelector(".btn_add.add_metall");

    const isAnyChecked = (nameSubstring) => {
        const checkboxes = document.querySelectorAll(`input[type="checkbox"][name*="${nameSubstring}"]`);
        return Array.from(checkboxes).some((cb) => cb.checked);
    };

    if (addDspBtn) {
        if (maxDspIndex >= thresholdNumberShelves) {
            addDspBtn.classList.add("disable");
        }
        if (!isAnyChecked("polka_pribornaya_dsp")) {
            addDspBtn.classList.add("disable");
        }
    }
    if (addMetallBtn) {
        if (maxMetallIndex >= thresholdNumberShelves) {
            addMetallBtn.classList.add("disable");
        }
        if (!isAnyChecked("polka_pribornaya_metall")) {
            addMetallBtn.classList.add("disable");
        }
    }
}

// Применяем значения к группе элементов
function applyValuesToElements(elements, values) {
    elements.forEach((element) => {
        if (element.type === "checkbox" || element.type === "radio") {
            const newChecked =
                Array.from(values).includes(element.value) ||
                (element.type === "checkbox" && Array.from(values).includes("on"));
            if (element.checked !== newChecked) {
                element.checked = newChecked;
                element.dispatchEvent(new Event("change", { bubbles: true }));
            }
        } else if (element.tagName === "SELECT") {
            if (element.multiple) {
                Array.from(element.options).forEach((option) => {
                    option.selected = values.has(option.value);
                });
            } else {
                const option = element.querySelector(`option[value="${Array.from(values)[0]}"]`);
                if (option) option.selected = true;
            }
        } else {
            element.value = Array.from(values).join(",");
        }
    });
}

export function resetForm(formId) {
    const form = document.getElementById(formId);
    form?.reset(); // Сбрасываем форму

    hideAndRemoveAllActiveArrays();

    const tableWidth = servObj.tableSize.tableWidth;
    const tableDepth = servObj.tableSize.tableDepth;
    const tableColor = servObj.tableColor;
    const antistatic_img = document.querySelector(".antistatic_img");
    // Проверяем, выбрана ли опция "antistatic"
    const isAntistatic = document.querySelector("input[name='edition']:checked")?.value === "antistatic";

    tableWidth.current = tableWidth.default; // Устанавливаем ширину стола по умолчанию
    tableDepth.current = tableDepth.default; // Устанавливаем глубину стола по умолчанию
    tableColor.changeable_painted_metal_material.current = tableColor.changeable_painted_metal_material.default; // Устанавливаем цвет металла по умолчанию
    tableColor.changeable_kromka_material.current = tableColor.changeable_kromka_material.default; // Устанавливаем цвет кромки по умолчанию

    resetShelfBlocks();

    // Сбрасываем preventForm
    if (servObj.redactorModeObject?.userData.preventForm) {
        servObj.redactorModeObject.userData.preventForm = null;
    }

    antistatic_img.classList.toggle("hide", !isAntistatic);

    // Триггерим событие change на форме
    const formEvent = new Event("change", { bubbles: true });
    form?.dispatchEvent(formEvent);
}

export async function resetFormAndDispatchChanges(formId) {
    const form = document.getElementById(formId);
    if (!form) return;

    const inputs = Array.from(form.querySelectorAll("input"));
    const originalStates = new Map();

    // Сохраняем старое состояние
    inputs.forEach((input) => {
        if (input.type === "checkbox" || input.type === "radio") {
            originalStates.set(input, input.checked);
        } else {
            originalStates.set(input, input.value);
        }
    });

    form.reset();

    const tableWidth = servObj.tableSize.tableWidth;
    const tableDepth = servObj.tableSize.tableDepth;
    const tableColor = servObj.tableColor;
    const antistatic_img = document.querySelector(".antistatic_img");
    // Проверяем, выбрана ли опция "antistatic"
    const isAntistatic = document.querySelector("input[name='edition']:checked")?.value === "antistatic";

    if (servObj.redactorModeObject?.userData.preventForm) {
        servObj.redactorModeObject.userData.preventForm = null;
    }

    antistatic_img.classList.toggle("hide", !isAntistatic);
    const formEvent = new Event("change", { bubbles: true });
    form.dispatchEvent(formEvent);

    const down_elems_block = form.querySelector(".down_elems_block");
    const up_elems_block = form.querySelector(".up_elems_block");

    // Создаём мапу для radio-групп
    const radioGroups = new Map();

    // Обёртываем первый requestAnimationFrame в Promise, чтобы ждать его
    await new Promise((resolve) => {
        requestAnimationFrame(() => {
            inputs.forEach((input) => {
                let changed = false;

                if (input.type === "radio") {
                    const name = input.name;
                    if (!radioGroups.has(name)) radioGroups.set(name, []);
                    radioGroups.get(name).push(input);
                } else if (input.type === "checkbox") {
                    changed = input.checked !== originalStates.get(input);
                } else {
                    changed = input.value !== originalStates.get(input);
                }

                if (changed) {
                    const changeEvent = new Event("change", { bubbles: true });
                    input.dispatchEvent(changeEvent);
                }
            });

            radioGroups.forEach((groupInputs) => {
                const anyChanged = groupInputs.some((input) => input.checked !== originalStates.get(input));

                if (anyChanged) {
                    const currentlyChecked = groupInputs.find((i) => i.checked);
                    if (currentlyChecked) {
                        const changeEvent = new Event("change", { bubbles: true });
                        currentlyChecked.dispatchEvent(changeEvent);
                    }
                }
            });

            if (up_elems_block) up_elems_block.classList.remove("visible");
            if (down_elems_block) down_elems_block.classList.add("visible");

            tableWidth.current = tableWidth.default;
            tableDepth.current = tableDepth.default;
            tableColor.changeable_kromka_material.current = tableColor.changeable_kromka_material.default;
            tableColor.changeable_painted_metal_material.current = tableColor.changeable_painted_metal_material.default;

            resolve(); // Сигнал о завершении
        });
    });

    // Второй тоже обернуть, чтобы ждать его:
    await new Promise((resolve) => {
        requestAnimationFrame(() => {
            resetShelfBlocks();
            resetDerzhatelBlocks();
            resetDopPolkaBlocks();
            resolve();
        });
    });

    // КОСТЫЛЬ
    // нужен тогда, когда у тебя много на столе навешено элементов и эта функция сбрасывает все, кроме перфопанели.
    changePerfopanel(700, false);

    const isStellazh = servObj.redactorModeObject.userData.loadData.folderName === "stellazhi";

    if (isStellazh) {
        const currentStellazhShelvesPos = Y_MAP_SHELVES[servObj.tempName][servObj.tableSize.tableHeight.current];
        const currentStellazhShelvesPosValues = Object.values(currentStellazhShelvesPos);
        servObj.activePolkaStellazh.forEach((polka, index) => {
            polka.position.y = currentStellazhShelvesPosValues[index];
        });
    }
}

onElementAdded("#form-object-params", () => {
    if (servObj.redactorModeObject?.userData.preventForm) {
        applyFormData(servObj.redactorModeObject.userData.preventForm, "form-object-params");
    }
});

function processDerzhatelData(form, valueGroups) {
    const maxDerzhatelIndex = getMaxDerzhatelIndex(valueGroups);
    const servObj = window?.servObj || parent.window?.servObj;

    // Добавляем недостающие блоки держателей с autoCheck = false
    for (let i = 2; i <= maxDerzhatelIndex; i++) {
        if (i <= servObj.thresholdDerzhatel) {
            addDerzhatelBlock(i, false); // Не чекаем автоматически
            servObj.counterDerzhatel = i + 1;
        }
    }

    // Применяем значения к держателям
    applyDerzhatelValues(form, valueGroups, maxDerzhatelIndex);

    // Обновляем кнопку добавления
    updateDerzhatelAddButton(maxDerzhatelIndex);
}

function getMaxDerzhatelIndex(valueGroups) {
    let maxIndex = 1;
    for (const [name] of valueGroups) {
        const match = name.match(/^derzhatel_rulona__(\d+)$/);
        if (match) {
            const index = parseInt(match[1]);
            if (index > maxIndex) maxIndex = index;
        }
    }
    return Math.min(maxIndex, servObj.thresholdDerzhatel);
}

function applyDerzhatelValues(form, valueGroups, maxIndex) {
    for (let i = 1; i <= maxIndex; i++) {
        const derzhatelName = `derzhatel_rulona__${i}`;
        const derzhatelInput = form.querySelector(`input[name="${derzhatelName}"]`);
        const fiksatoriWrap = document.querySelector(`.bokovie_fiksatori_wrap__${i}`);

        if (derzhatelInput) {
            // Проверяем наличие значения "on" для держателя
            const shouldBeChecked =
                valueGroups.has(derzhatelName) && Array.from(valueGroups.get(derzhatelName)).includes("on");
            derzhatelInput.checked = shouldBeChecked;

            // Управляем состоянием обертки фиксаторов
            if (shouldBeChecked) {
                fiksatoriWrap?.classList.remove("disable");

                // Применяем состояние фиксаторов если держатель активен
                const fiksatoriName = `bokovie_fiksatori__${i}`;
                if (valueGroups.has(fiksatoriName)) {
                    const fiksatoriValues = valueGroups.get(fiksatoriName);
                    // Проверяем значение "on" для фиксаторов
                    const shouldCheckFiksatori = Array.from(fiksatoriValues).includes("on");

                    const fiksatoriInput = form.querySelector(`input[name="${fiksatoriName}"]`);
                    if (fiksatoriInput) {
                        fiksatoriInput.checked = shouldCheckFiksatori;
                        fiksatoriInput.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                }
            } else {
                fiksatoriWrap?.classList.add("disable");
                // Сбрасываем фиксаторы если держатель неактивен
                const fiksatoriInput = fiksatoriWrap?.querySelector(`input[name="bokovie_fiksatori__${i}"]`);
                if (fiksatoriInput) {
                    fiksatoriInput.checked = false;
                    fiksatoriInput.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }

            derzhatelInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }
}

function updateDerzhatelAddButton(maxIndex) {
    const addBtn = document.querySelector(".add_derzhatel");
    if (!addBtn) return;

    const isAnyChecked = () => {
        const checkboxes = document.querySelectorAll(`input[type="checkbox"][name^="derzhatel_rulona__"]`);
        return Array.from(checkboxes).some((cb) => cb.checked);
    };

    if (maxIndex >= servObj.thresholdDerzhatel) {
        addBtn.classList.add("disable");
    }
    if (!isAnyChecked()) {
        addBtn.classList.add("disable");
    }
}

// --- Дополнительные полки --- //
function processDopPolkaData(form, valueGroups) {
    const maxDopPolkaIndex = getMaxDopPolkaIndex(valueGroups);
    const servObj = window?.servObj || parent.window?.servObj;

    // Добавляем недостающие блоки (без авточек)
    for (let i = 2; i <= maxDopPolkaIndex; i++) {
        if (i <= thresholdDopPolka) {
            addDopPolkaBlock(i, false);
            servObj.counterDopPolka = i + 1;
        }
    }

    // Применяем состояния чекбоксов
    applyDopPolkaValues(form, valueGroups, maxDopPolkaIndex);

    // Обновляем кнопку
    updateDopPolkaAddButton(maxDopPolkaIndex);
}

function getMaxDopPolkaIndex(valueGroups) {
    let maxIndex = 1;
    for (const [name] of valueGroups) {
        const match = name.match(/^dopolnitelnaya_polka__(\d+)$/);
        if (match) {
            const index = parseInt(match[1]);
            if (index > maxIndex) maxIndex = index;
        }
    }
    return Math.min(maxIndex, thresholdDopPolka);
}

function applyDopPolkaValues(form, valueGroups, maxIndex) {
    for (let i = 1; i <= maxIndex; i++) {
        const polkaName = `dopolnitelnaya_polka__${i}`;
        const polkaInput = form.querySelector(`input[name="${polkaName}"]`);

        if (polkaInput) {
            // Чекбокс активен, если есть "on"
            const shouldBeChecked = valueGroups.has(polkaName) && Array.from(valueGroups.get(polkaName)).includes("on");
            polkaInput.checked = shouldBeChecked;

            // Дёргаем change, чтобы всё обновилось
            polkaInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }
}

function updateDopPolkaAddButton(maxIndex) {
    const addBtn = document.querySelector(".add_dop_polka");
    if (!addBtn) return;

    const isAnyChecked = () => {
        const checkboxes = document.querySelectorAll(`input[type="checkbox"][name^="dopolnitelnaya_polka__"]`);
        return Array.from(checkboxes).some((cb) => cb.checked);
    };

    if (maxIndex >= thresholdDopPolka) {
        addBtn.classList.add("disable");
    }
    if (!isAnyChecked()) {
        addBtn.classList.add("disable");
    }
}
